import React from 'react';
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { useForm, Controller } from "react-hook-form";
import configurations from 'config';
import axios from "axios";
import Multiselect from 'multiselect-react-dropdown';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from "@mui/material";
import { InputAdornment, Icon } from "@mui/material";
import { CUSTOM_FIELD } from 'constants.js';
import { checkPrivilege, convertToBase64 } from "common.js";
import { handleErrors } from 'common';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const RenderCustomField = (props) => {
  const { dataFrom, item, from, t, productId, setSelectedRow,
    register, control, setValue, setError, errors, selectedCustomMultiselect, setSelectedCustomMultiselect,
    setCategoryCustomFields, customFields, setCustomFields, categoryCustomFields,
    setIsLoading } = props;

  const navigate = useNavigate();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;

  const onSelectCustomField = (fieldName) => (selectedList, selectedItem) => {
    setSelectedCustomMultiselect((prevOptions) => ({
      ...prevOptions,
      [fieldName]: selectedList,
    }));
  };

  const onRemoveCustomfield = (fieldName) => (selectedList, removedItem) => {
    setSelectedCustomMultiselect((prevOptions) => {
      const updatedSelected = {
        ...prevOptions,
        [fieldName]: prevOptions[fieldName].filter((item) => item.name !== removedItem.name),
      };
      return updatedSelected;
    });
  };


  const handleFileChange = async (e, id, fieldName, maxSize, types, from) => {
    const file = e.target.files[0];
    const fileName = file.name;
    const parts = fileName.split('.');
    const fileFormat = parts[1];
    const fileSizeInBytes = file.size;
    const fileSizeInMB = (fileSizeInBytes / (1024 * 1024)).toFixed(3);
    if (file) {
      if (!types.includes(fileFormat)) {
        setError(fieldName, {
          message: t('invalidFileFormat')
        });
      }
      else if (fileSizeInMB >= maxSize) {
        setError(fieldName, {
          message: t('fileMaxSize', { maxSize })
        });
      }
      else {
        setError(fieldName, { message: '' });
        const base64 = await convertToBase64(file);
        if (dataFrom == "vendor") {
          const fileData = { customFieldId: id, fieldName: fieldName, fileInfo: base64, fileName: fileName };
          setIsLoading(true)
          axios.post(baseUrl + '/vendor/addVendorCustomFile', fileData, {
            headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
          })
            .then((response) => {
              setIsLoading(false)
              if (response.status == 200) {
                const status = response.data.status;
                const message = response.data.message;
                if (status == 1) {
                  const objectWithIdOne = customFields.find((item) => item.id === id);
                  if (objectWithIdOne) {
                    objectWithIdOne.fileData = response.data.data.fileURL;
                    objectWithIdOne.fileType = response.data.data.fileType;
                    objectWithIdOne.azureId = response.data.data.azureId;
                    const index = customFields.findIndex((item) => item.id === id);
                    if (index !== -1) {
                      const updatedCustomFields = [
                        ...customFields.slice(0, index),
                        objectWithIdOne,
                        ...customFields.slice(index + 1)
                      ];
                      setCustomFields(updatedCustomFields);
                    }
                  }
                  toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                }
                else {
                  if (message != '')
                    toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                  if (response && response.data && response.data.errors) {
                    const errorData = response.data.errors;
                    errorData.forEach((error) => {
                      setError(error.field, {
                        type: 'server',
                        message: t(error.errors[0])
                      });
                    });
                  }
                }
              }
              else {
                toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
              }
            })
            .catch(error => {
              setIsLoading(false)
              handleErrors(error, t, navigate);
            });
        }
        else {
          const fileData = { customFieldId: id, productId: productId, dataFrom: dataFrom, fieldName: fieldName, fileInfo: base64, fileName: fileName };
          setIsLoading(true)
          axios.post(baseUrl + '/product/addProductCustomFile', fileData, {
            headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
          }).then((response) => {
            setIsLoading(false)
            if (response.status == 200) {
              const status = response.data.status;
              const message = response.data.message;
              if (status == 1) {
                if (from == "general") {
                  const objectWithIdOne = customFields.find((item) => item.id === id);
                  if (objectWithIdOne) {
                    objectWithIdOne.fileData = response.data.data.fileURL;
                    objectWithIdOne.fileType = response.data.data.fileType;
                    objectWithIdOne.azureId = response.data.data.azureId;
                    const index = customFields.findIndex((item) => item.id === id);
                    if (index !== -1) {
                      const updatedCustomFields = [
                        ...customFields.slice(0, index),
                        objectWithIdOne,
                        ...customFields.slice(index + 1)
                      ];
                      setCustomFields(updatedCustomFields);
                    }
                  }
                }
                else {
                  const objectWithIdOne = categoryCustomFields.find((item) => item.id === id);
                  if (objectWithIdOne) {
                    objectWithIdOne.fileData = response.data.data.fileURL;
                    objectWithIdOne.fileType = response.data.data.fileType;
                    objectWithIdOne.azureId = response.data.data.azureId;
                    const index = categoryCustomFields.findIndex((item) => item.id === id);
                    if (index !== -1) {
                      const updatedCustomFields = [
                        ...categoryCustomFields.slice(0, index),
                        objectWithIdOne,
                        ...categoryCustomFields.slice(index + 1)
                      ];
                      setCategoryCustomFields(updatedCustomFields);
                    }
                  }
                }
                toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
              }
              else {
                if (message != '')
                  toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
                if (response && response.data && response.data.errors) {
                  const errorData = response.data.errors;
                  errorData.forEach((error) => {
                    setError(error.field, {
                      type: 'server',
                      message: t(error.errors[0])
                    });
                  });
                }
              }
            }
            else {
              toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
            }
          })
            .catch(error => {
              setIsLoading(false)
              handleErrors(error, t, navigate);
            });
        }

      }
    }
  };

  const handleFileDelete = async (e, id, from) => {
    let objectWithId = {};
    if (from == "general")
      objectWithId = customFields.find((item) => item.id === id);
    else
      objectWithId = categoryCustomFields.find((item) => item.id === id);
    if (dataFrom == 'vendor') {
      const fileData = { azureId: objectWithId.azureId, customFieldId: id, fileUrl: objectWithId.fileData ? objectWithId.fileData : objectWithId.value };
      setIsLoading(true)
      axios.post(baseUrl + '/vendor/deleteVendorCustomFile', fileData, {
        headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
      }).then((response) => {
        setIsLoading(false)
        if (response.status == 200) {
          const status = response.data.status;
          const message = response.data.message;
          if (status == 1) {
            if (objectWithId) {
              objectWithId.fileData = '';
              objectWithId.fileType = '';
              objectWithId.azureId = '';
              objectWithId.value = '';
              setValue(objectWithId.fieldName, null);
              const index = customFields.findIndex((item) => item.id === id);
              if (index !== -1) {
                const updatedCustomFields = [
                  ...customFields.slice(0, index),
                  objectWithId,
                  ...customFields.slice(index + 1)
                ];
                setCustomFields(updatedCustomFields);
              }
            }
            toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
          }
          else {
            if (message != '')
              toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
            if (response && response.data && response.data.errors) {
              const errorData = response.data.errors;
              errorData.forEach((error) => {
                setError(error.field, {
                  type: 'server',
                  message: t(error.errors[0])
                });
              });
            }
          }
        }
        else {
          toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
        }
      }).catch(error => {
        setIsLoading(false)
        handleErrors(error, t, navigate);
      });
    }
    else {
      const fileData = { azureId: objectWithId.azureId, productId: productId, dataFrom: dataFrom, customFieldId: id, fileUrl: objectWithId.fileData ? objectWithId.fileData : objectWithId.value };
      setIsLoading(true)

      axios.post(baseUrl + '/product/deleteProductCustomFile', fileData, {
        headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
      })
        .then((response) => {
          setIsLoading(false)
          if (response.status == 200) {
            const status = response.data.status;
            const message = response.data.message;
            let index = {};
            if (status == 1) {
              if (objectWithId) {
                objectWithId.fileData = '';
                objectWithId.fileType = '';
                objectWithId.azureId = '';
                objectWithId.value = '';
                setValue(objectWithId.fieldName, null);
                if (from == "general") {
                  index = customFields.findIndex((item) => item.id === id);
                  if (index !== -1) {
                    const updatedCustomFields = [
                      ...customFields.slice(0, index),
                      objectWithId,
                      ...customFields.slice(index + 1)
                    ];
                    setCustomFields(updatedCustomFields);
                  }
                }
                else {
                  index = categoryCustomFields.findIndex((item) => item.id === id);
                  if (index !== -1) {
                    const updatedCustomFields = [
                      ...categoryCustomFields.slice(0, index),
                      objectWithId,
                      ...categoryCustomFields.slice(index + 1)
                    ];
                    setCategoryCustomFields(updatedCustomFields);
                  }
                }
              }
              toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
            }
            else {
              if (message != '')
                toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
              if (response && response.data && response.data.errors) {
                const errorData = response.data.errors;
                errorData.forEach((error) => {
                  setError(error.field, {
                    type: 'server',
                    message: t(error.errors[0])
                  });
                });
              }
            }
          }
          else {
            toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
          }
        }).catch(error => {
          setIsLoading(false)
          handleErrors(error, t, navigate);
        });
    }

  }

  const handleDownload = async (e, id, from) => {
    let objectWithId = {};
    if (from == "general")
      objectWithId = customFields.find((item) => item.id === id);
    else
      objectWithId = categoryCustomFields.find((item) => item.id === id);
    const fileData = { azureId: objectWithId.azureId, id: id, fileUrl: objectWithId.fileData ? objectWithId.fileData : objectWithId.value };
    const downloadLink = document.createElement('a');
    downloadLink.href = objectWithId.fileData ? objectWithId.fileData : objectWithId.value; // URL of the file to download
    downloadLink.download = objectWithId.fieldName; // Name of the downloaded file
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

  }

  if (item.fieldType === CUSTOM_FIELD.TEXT) {
    const fieldName = item.fieldName;
    const isFieldRequired = item.mandatory || false;
    return (
      <MDBox mb={1} key={item.id}>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <MDTypography variant="body1" className="labelStyle">
              {item.displayName + " "}
              {isFieldRequired ?
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                :
                null}
            </MDTypography>
          </Grid>
          <Grid item xs={12} sm={8} md={8}>
            <Controller
              name={fieldName}
              control={control}
              rules={{
                required: isFieldRequired ? t('required') : false,
              }}
              defaultValue={item.value || ''}
              render={({ field }) => (
                <MDInput
                  type="text"
                  {...field}
                  fullWidth
                  InputProps={{
                    classes: { root: "inputBoxStyle" },
                  }}
                />
              )}
            />
            {errors[fieldName] && <span className="errorMsg FloatRight">{errors[fieldName].message}</span>}
          </Grid>
        </Grid>
      </MDBox>
    );
  }
  else if (item.fieldType === CUSTOM_FIELD.DROPDOWN) {
    const fieldName = item.fieldName;
    const isFieldRequired = item.mandatory || false;
    let lists = [];
    if (item.values.length > 0)
      lists = JSON.parse(item.values);
    else
      lists = [];
    return (
      <MDBox mb={1} key={item.id}>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <MDTypography variant="body1" className="labelStyle">
              {item.displayName + " "}
              {isFieldRequired ?
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                :
                null}
            </MDTypography>
          </Grid>
          <Grid item xs={12} sm={8} md={8}>
            <Controller
              name={item.fieldName}
              control={control}
              rules={{
                required: isFieldRequired ? t('required') : false,
                validate: (value) => {
                  if (value === "0" && isFieldRequired) {
                    return t('required');
                  }
                  return true;
                },
              }}
              defaultValue={item.value || '0'}
              render={({ field }) => (
                <MDInput
                  select
                  {...field}
                  fullWidth
                  InputProps={{
                    classes: { root: "select-input-styles dropdownPadding" },
                  }}
                >
                  <MenuItem key={0} value="0">{t('select')}</MenuItem>
                  {lists.map((list) => (
                    <MenuItem key={list.option} value={list.option}>{list.option}</MenuItem>
                  ))}
                </MDInput>
              )}
            />
            {errors[fieldName] && <span className="errorMsg FloatRight">{errors[fieldName].message}</span>}
          </Grid>
        </Grid>
      </MDBox>
    );
  }
  else if (item.fieldType === CUSTOM_FIELD.NUMERIC) {
    const fieldName = item.fieldName;
    const isFieldRequired = item.mandatory || false;
    return (
      <MDBox mb={1} key={item.id}>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <MDTypography variant="body1" className="labelStyle">
              {item.displayName + " "}
              {isFieldRequired ?
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                :
                null}
            </MDTypography>
          </Grid>
          <Grid item xs={12} sm={8} md={8}>
            <Controller
              name={fieldName}
              control={control}
              rules={{
                required: isFieldRequired ? t('required') : false,
              }}
              defaultValue={item.value || 1}
              render={({ field }) => (
                <MDInput
                  type="number"
                  {...field}
                  fullWidth
                  InputProps={{
                    classes: { root: "inputBoxStyle" },
                    inputProps: { min: 1 },
                  }}
                />
              )}
            />
            {errors[fieldName] && <span className="errorMsg FloatRight">{errors[fieldName].message}</span>}
          </Grid>
        </Grid>
      </MDBox>
    );
  }
  else if (item.fieldType === CUSTOM_FIELD.DATE) {
    const fieldName = item.fieldName;
    const isFieldRequired = item.mandatory || false;
    return (
      <MDBox mb={1} key={item.id}>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <MDTypography variant="body1" className="labelStyle">
              {item.displayName + " "}
              {isFieldRequired ?
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                :
                null}
            </MDTypography>
          </Grid>
          <Grid item xs={12} sm={8} md={8}>
            <Controller
              name={fieldName}
              control={control}
              rules={{
                required: isFieldRequired ? t('required') : false,
              }}
              defaultValue={item.value || ''}
              render={({ field }) => (
                <MDInput
                  type="date"
                  {...field}
                  fullWidth
                  InputProps={{
                    classes: { root: "inputBoxStyle" },
                  }}
                />
              )}
            />
            {errors[fieldName] && <span className="errorMsg FloatRight">{errors[fieldName].message}</span>}
          </Grid>
        </Grid>
      </MDBox>
    );
  }
  else if (item.fieldType === CUSTOM_FIELD.TEXTAREA) {
    const fieldName = item.fieldName;
    const isFieldRequired = item.mandatory || false;
    return (
      <MDBox mb={1} key={item.id}>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <MDTypography variant="body1" className="labelStyle">
              {item.displayName + " "}
              {isFieldRequired ?
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                :
                null}
            </MDTypography>
          </Grid>
          <Grid item xs={12} sm={8} md={8}>
            <Controller
              name={fieldName}
              control={control}
              rules={{
                required: isFieldRequired ? t('required') : false,
              }}
              defaultValue={item.value || ''}
              render={({ field }) => (
                <MDInput
                  type="text"
                  multiline
                  maxRows={8}
                  {...field}
                  fullWidth
                  InputProps={{
                    classes: { root: "textareaHeight" },
                  }}
                  onChange={(e) => { setValue(fieldName, e.target.value) }}
                />
              )}
            />
            {errors[fieldName] && <span className="errorMsg FloatRight">{errors[fieldName].message}</span>}
          </Grid>
        </Grid>
      </MDBox>
    );
  }
  else if (item.fieldType === CUSTOM_FIELD.MULTISELECT) {
    const fieldName = item.fieldName;
    const isFieldRequired = item.mandatory || false;
    const lists = JSON.parse(item.values);
    const multipleArray = [];
    lists.forEach(element => {
      multipleArray.push({ 'name': element.option })
    });
    return (
      <MDBox mb={1} key={item.id}>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <MDTypography variant="body1" className="labelStyle">
              {item.displayName + " "}
              {isFieldRequired ?
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                :
                null}
            </MDTypography>
          </Grid>
          <Grid item xs={12} sm={8} md={8}>
            <Multiselect
              options={multipleArray}
              selectedValues={item.value || selectedCustomMultiselect[fieldName]}
              onSelect={onSelectCustomField(fieldName)}
              onRemove={onRemoveCustomfield(fieldName)}
              displayValue="name"
              name={fieldName}
              className="MultiSelectStyle"
              {...register(fieldName, {
                required: {
                  value: (isFieldRequired && !(selectedCustomMultiselect[fieldName]?.length > 0)),
                  message: t('required')
                }
              })}
            />
            {errors[fieldName] && <span className="errorMsg FloatRight">{errors[fieldName].message}</span>}
          </Grid>
        </Grid>
      </MDBox>
    );
  }
  else if (item.fieldType === CUSTOM_FIELD.FILE) {
    const id = item.id;
    const fieldName = item.fieldName;
    const isFieldRequired = item.mandatory || false;
    const additionalInfo = JSON.parse(item.additionalInfo);
    const maxSize = additionalInfo.fileSize;
    const types = additionalInfo.type;
    const extensionsArray = types.split(',');
    const value = item.value;
    let fileContent = '';
    if (item.fileData)
      fileContent = item.fileData;
    else
      fileContent = item.value;
    var fileName = '';
    if (fileContent) {
      const parsedUrl = new URL(fileContent);
      const pathname = parsedUrl.pathname;
      const segments = pathname.split('/');
      fileName = segments[segments.length - 1];
    }
    return (
      <MDBox mb={1} key={item.id}>
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <MDTypography variant="body1" className="labelStyle">
              {item.displayName + " "}
              {isFieldRequired ?
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                :
                null}
            </MDTypography>
          </Grid>
          <Grid item xs={12} sm={8} md={8}>
            <MDInput
              type="file"
              name={fieldName}
              {...register(fieldName, {
                required: isFieldRequired ? value ? false : t('required') : false,
              })}
              onChange={((e) => {
                e.stopPropagation()
                const file = e.target.files[0];
                if (file) {
                  handleFileChange(e, item.id, fieldName, maxSize, extensionsArray, from)
                }
              })}
              fullWidth />
            {errors[fieldName] && <span className="errorMsg FloatRight">{errors[fieldName].message}</span>}
            <MDTypography component="span" variant="body2" color="info" className="NoteText">
              {t('format', { types, maxSize })}
            </MDTypography>
            {((fileContent) && item.fileType == 'image') ?
              <>
                <MDBox component="img" src={fileContent} className="customFieldImage" />
                <IconButton
                  className="PositionAbsolute"
                  size="small"
                  disableRipple
                  variant="contained"
                  onClick={(e) => { handleFileDelete(e, id, from) }}
                >
                  <Icon className="closeIcon">close</Icon>
                </IconButton>
              </>
              :
              fileName ?
                <MDBox>
                  <MDTypography variant="body1" className="labelStyle SelectPdfFormat">{fileName}</MDTypography>
                  <IconButton
                    size="small"
                    disableRipple
                    variant="contained"
                    onClick={(e) => { handleDownload(e, id, from) }}
                  >
                    <Icon className="closeIcon">download</Icon>
                  </IconButton>
                  <IconButton
                    size="small"
                    disableRipple
                    variant="contained"
                    onClick={(e) => { handleFileDelete(e, id, from) }}
                  >
                    <Icon className="closeIcon">close</Icon>
                  </IconButton>
                </MDBox>
                :
                null
            }
          </Grid>
        </Grid>
      </MDBox>
    );
  }
  else {
    return null;
  }
};
export default RenderCustomField;
